import styled, { css } from 'styled-components'

export const NoWorkspacesDropdown = styled.div`
  cursor: pointer;
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
`

export const NoWorkspacesAvatar = styled.div`
  ${({ theme }) => css`
    height: 24px;
    width: 24px;

    background-color: ${theme.colors.background.tertiary[2]};
    border-radius: 4px;
  `}
`

export const NoWorkspacesTitle = styled.span`
  ${({ theme }) => css`
    flex: 1;
    margin-left: 12px;

    color: ${theme.colors.foreground.secondary[4]};
    font-size: ${theme.fontSizes.small};
    font-weight: ${theme.fontWeights.medium};
  `}
`

export const NoWorkspacesIcon = styled.div`
  ${({ theme }) => css`
    width: 8px;
    margin: 4px 8px 0 0;
    color: ${theme.colors.state.disabled};
  `}
`
